import { createRouter, createWebHashHistory } from 'vue-router'
import { getHashQueryParam } from '../../utilities'

const router = () => {
	return createRouter(
		{
			history: createWebHashHistory(),
			routes: [
				{
					path: '/',
					redirect: { name: 'service' },
					beforeEnter: (to, from, next) => {
						next()
					},
					children: [
						{
							path: 'service',
							name: 'service',
							component: () => import('@views/booking/service/Index.vue')
						},
						{
							path: 'staff',
							name: 'staff',
							component: () => import('@views/booking/staff/Index.vue')
						},
						{
							path: 'staff/:staff_id',
							name: 'staff.profile',
							component: () => import('@views/booking/staff/StaffProfile.vue')
						},
						{
							path: 'date',
							name: 'date',
							component: () => import('@views/booking/date/Index.vue')
						},
						{
							path: 'time',
							name: 'time',
							component: () => import('@views/booking/time/Index.vue')
						},
						{
							path: 'appointment/type',
							name: 'appointment.type',
							component: () => import('@views/booking/appointment/Index.vue')
						},
						{
							path: 'requirements',
							name: 'requirements',
							component: () => import('@views/booking/requirements/Index.vue')
						},
						{
							path: 'account',
							name: 'account',
							component: () => import('@views/booking/account/Index.vue')
						},
						{
							path: 'overview',
							name: 'overview',
							component: () => import('@views/booking/overview/Index.vue')
						},
						{
							path: 'confirmation',
							name: 'confirmation',
							component: () => import('@views/booking/confirmation/Index.vue'),
							beforeEnter: (to, from, next) => {
								if (from.name == 'overview' || getHashQueryParam('prebook_payment') == 'success') {
									next()
								} else {
									next({ name: 'overview' })
								}
							}
						},
					]
				},
				{
					path: '/:pathMatch(.*)*',
					name: 'not-found',
					component: () => import('@views/booking/other/NotFound.vue'),
				}
			]
		}
	)
}

export default router